// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Icon, { IconPresentationProps, IconProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { XNGAGE_CUSTOM_WIDGET } from "@west/XDL/constants";
import Help from "@west/XDL/Icons/Help";
import { xScreen } from "@west/XDL/Utilities";
import xDefaultRules from "@west/XDL/Utilities/xValidate/xDefaultRules";
import validate from "@west/XDL/Utilities/xValidate/xValidate";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    description = "description",
    phoneText = "phoneText",
}

export interface NeedSupportProps {
    fields: {
        [fields.description]: string;
        [fields.phoneText]: string;
    };
}

interface OwnProps extends NeedSupportProps {}

interface NeedSupportStyles {
    container?: InjectableCss;
    textWrapper?: InjectableCss;
    iconStyles?: IconPresentationProps;
    textStyles?: TypographyPresentationProps;
    phoneLink?: LinkPresentationProps;
}

export const needSupportStyles: NeedSupportStyles = {};

const styles = needSupportStyles;

const NeedSupport: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.textWrapper}>
                <Icon src={Help} size={18} {...styles.iconStyles}></Icon>
                <Typography {...styles.textStyles}>{fields.description}</Typography>
            </StyledWrapper>
            <Link aria-label={fields.phoneText} href={`tel:${fields.phoneText}`} {...styles.phoneLink} target="_blank">
                {fields.phoneText}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: NeedSupport,
    definition: {
        group: XNGAGE_CUSTOM_WIDGET as any,
        fieldDefinitions: [
            {
                name: fields.description,
                fieldType: "Translatable",
                defaultValue: "Need Support?",
                editorTemplate: "TextField",
            },
            {
                name: fields.phoneText,
                fieldType: "Translatable",
                defaultValue: "(123) 456-7890",
                editorTemplate: "TextField",
                validate: value => {
                    if (!value) {
                        return null;
                    }

                    return validate(value, xDefaultRules["phone"]);
                },
            },
        ],
    },
};

export default widgetModule;
